"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageRawPayloadOut = void 0;
class MessageRawPayloadOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageRawPayloadOut.attributeTypeMap;
    }
}
exports.MessageRawPayloadOut = MessageRawPayloadOut;
MessageRawPayloadOut.discriminator = undefined;
MessageRawPayloadOut.attributeTypeMap = [
    {
        "name": "payload",
        "baseName": "payload",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=MessageRawPayloadOut.js.map